//STAKING
import singleTicket from '../../assets/images/backoffice/ticketImages/1TICKET.png';
import twoTickets from '../../assets/images/backoffice/ticketImages/2TICKETS.png';
import fiveTickets from '../../assets/images/backoffice/ticketImages/5TICKETS.png';
import tenTickets from '../../assets/images/backoffice/ticketImages/10TICKETS.png';
import twentyFiveTickets from '../../assets/images/backoffice/ticketImages/25TICKETS.png';
import fiftyTickets from '../../assets/images/backoffice/ticketImages/50TICKETS.png';
import oneHundredTickets from '../../assets/images/backoffice/ticketImages/100TICKETS.png';
import threeHundredTickets from '../../assets/images/backoffice/ticketImages/300TICKETS.png';

//CANCUN
import singleTicketCancun from '../../assets/images/backoffice/cancunPromo/ticketImages/1TICKET.png';
import twoTicketsCancun from '../../assets/images/backoffice/cancunPromo/ticketImages/2TICKETS.png';
import fiveTicketsCancun from '../../assets/images/backoffice/cancunPromo/ticketImages/5TICKETS.png';
import tenTicketsCancun from '../../assets/images/backoffice/cancunPromo/ticketImages/10TICKETS.png';
import twentyFiveTicketsCancun from '../../assets/images/backoffice/cancunPromo/ticketImages/25TICKETS.png';
import fiftyTicketsCancun from '../../assets/images/backoffice/cancunPromo/ticketImages/50TICKETS.png';
import oneHundredTicketsCancun from '../../assets/images/backoffice/cancunPromo/ticketImages/100TICKETS.png';
import threeHundredTicketsCancun from '../../assets/images/backoffice/cancunPromo/ticketImages/300TICKETS.png';

export const eventData = [
  {
    id: 25,
    image: singleTicket
  },
  {
    id: 26,
    image: twoTickets
  },
  {
    id: 27,
    image: fiveTickets
  },
  {
    id: 28,
    image: tenTickets
  },
  {
    id: 29,
    image: twentyFiveTickets
  },
  {
    id: 30,
    image: fiftyTickets
  },
  {
    id: 31,
    image: oneHundredTickets
  },
  {
    id: 32,
    image: threeHundredTickets
  },

  //cancun
  {
    id: 49,
    image: singleTicketCancun
  },
  {
    id: 50,
    image: twoTicketsCancun
  },
  {
    id: 51,
    image: fiveTicketsCancun
  },
  {
    id: 52,
    image: tenTicketsCancun
  },
  {
    id: 53,
    image: twentyFiveTicketsCancun
  },
  {
    id: 54,
    image: fiftyTicketsCancun
  },
  {
    id: 55,
    image: oneHundredTicketsCancun
  },
  {
    id: 56,
    image: threeHundredTicketsCancun
  }
];
